import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class CobbledRoadTileEntity2 extends TileEntity {
	public static readonly frameName = FrameName.COBBLED_ROAD_2;
}

export default CobbledRoadTileEntity2;
